var moduleMap = {
	"./Navigation": function() {
		return Promise.all([__webpack_require__.e(4223), __webpack_require__.e(3460), __webpack_require__.e(4920), __webpack_require__.e(8803), __webpack_require__.e(4305), __webpack_require__.e(2846), __webpack_require__.e(190), __webpack_require__.e(9926)]).then(function() { return function() { return (__webpack_require__(2442)); }; });
	},
	"./Footer": function() {
		return Promise.all([__webpack_require__.e(4920), __webpack_require__.e(4305), __webpack_require__.e(2846), __webpack_require__.e(6321)]).then(function() { return function() { return (__webpack_require__(6321)); }; });
	},
	"./ErrorPage": function() {
		return Promise.all([__webpack_require__.e(4920), __webpack_require__.e(4305), __webpack_require__.e(7567)]).then(function() { return function() { return (__webpack_require__(7567)); }; });
	},
	"./DataGridCellRenderers": function() {
		return Promise.all([__webpack_require__.e(4223), __webpack_require__.e(3460), __webpack_require__.e(899), __webpack_require__.e(8980), __webpack_require__.e(4920), __webpack_require__.e(8803), __webpack_require__.e(4305), __webpack_require__.e(2846), __webpack_require__.e(5773), __webpack_require__.e(355), __webpack_require__.e(4299)]).then(function() { return function() { return (__webpack_require__(1080)); }; });
	},
	"./SBOPTLogo": function() {
		return Promise.all([__webpack_require__.e(4920), __webpack_require__.e(4539)]).then(function() { return function() { return (__webpack_require__(9157)); }; });
	},
	"./GenericTable": function() {
		return Promise.all([__webpack_require__.e(4920), __webpack_require__.e(5701), __webpack_require__.e(1572)]).then(function() { return function() { return (__webpack_require__(4994)); }; });
	},
	"./RecommendationRow": function() {
		return Promise.all([__webpack_require__.e(4920), __webpack_require__.e(4305), __webpack_require__.e(8087)]).then(function() { return function() { return (__webpack_require__(8087)); }; });
	},
	"./ModifyRecommendationsModal": function() {
		return Promise.all([__webpack_require__.e(4223), __webpack_require__.e(3460), __webpack_require__.e(4920), __webpack_require__.e(8803), __webpack_require__.e(4305), __webpack_require__.e(355)]).then(function() { return function() { return (__webpack_require__(355)); }; });
	},
	"./IdleConfirmationModal": function() {
		return Promise.all([__webpack_require__.e(4223), __webpack_require__.e(3460), __webpack_require__.e(4920), __webpack_require__.e(8803), __webpack_require__.e(4305), __webpack_require__.e(2594)]).then(function() { return function() { return (__webpack_require__(2594)); }; });
	},
	"./StyledComponents": function() {
		return Promise.all([__webpack_require__.e(4920), __webpack_require__.e(8803), __webpack_require__.e(3842)]).then(function() { return function() { return (__webpack_require__(3842)); }; });
	},
	"./ErrorBoundary": function() {
		return Promise.all([__webpack_require__.e(4920), __webpack_require__.e(4305), __webpack_require__.e(2643)]).then(function() { return function() { return (__webpack_require__(2643)); }; });
	},
	"./DatePicker": function() {
		return Promise.all([__webpack_require__.e(8337), __webpack_require__.e(386)]).then(function() { return function() { return (__webpack_require__(386)); }; });
	},
	"./BIReport": function() {
		return Promise.all([__webpack_require__.e(4920), __webpack_require__.e(8327), __webpack_require__.e(2181)]).then(function() { return function() { return (__webpack_require__(2181)); }; });
	},
	"./Dropdown": function() {
		return Promise.all([__webpack_require__.e(4920), __webpack_require__.e(7256)]).then(function() { return function() { return (__webpack_require__(7256)); }; });
	},
	"./Utils": function() {
		return Promise.all([__webpack_require__.e(8337), __webpack_require__.e(341)]).then(function() { return function() { return (__webpack_require__(341)); }; });
	},
	"./Redirect": function() {
		return Promise.all([__webpack_require__.e(2846), __webpack_require__.e(2058)]).then(function() { return function() { return (__webpack_require__(2058)); }; });
	},
	"./CustomSnackBar": function() {
		return Promise.all([__webpack_require__.e(4920), __webpack_require__.e(3846)]).then(function() { return function() { return (__webpack_require__(3846)); }; });
	},
	"./ModalPopup": function() {
		return Promise.all([__webpack_require__.e(4223), __webpack_require__.e(3460), __webpack_require__.e(4920), __webpack_require__.e(8803), __webpack_require__.e(3487)]).then(function() { return function() { return (__webpack_require__(3487)); }; });
	},
	"./ToolbarComponents": function() {
		return Promise.all([__webpack_require__.e(5701), __webpack_require__.e(4245)]).then(function() { return function() { return (__webpack_require__(4245)); }; });
	},
	"./MessageBannerComponent": function() {
		return Promise.all([__webpack_require__.e(4920), __webpack_require__.e(5031)]).then(function() { return function() { return (__webpack_require__(5031)); }; });
	},
	"./WarningBanner": function() {
		return Promise.all([__webpack_require__.e(4920), __webpack_require__.e(2273)]).then(function() { return function() { return (__webpack_require__(2273)); }; });
	},
	"./AppNavigationLeft": function() {
		return Promise.all([__webpack_require__.e(4223), __webpack_require__.e(3460), __webpack_require__.e(4920), __webpack_require__.e(8803), __webpack_require__.e(4305), __webpack_require__.e(2846), __webpack_require__.e(190), __webpack_require__.e(8920)]).then(function() { return function() { return (__webpack_require__(8920)); }; });
	},
	"./Select": function() {
		return Promise.all([__webpack_require__.e(4223), __webpack_require__.e(3460), __webpack_require__.e(9124), __webpack_require__.e(899), __webpack_require__.e(4750), __webpack_require__.e(8803), __webpack_require__.e(5773), __webpack_require__.e(1130)]).then(function() { return function() { return (__webpack_require__(1130)); }; });
	},
	"./ReusableCard": function() {
		return Promise.all([__webpack_require__.e(4223), __webpack_require__.e(3460), __webpack_require__.e(4920), __webpack_require__.e(8803), __webpack_require__.e(4558)]).then(function() { return function() { return (__webpack_require__(4558)); }; });
	},
	"./ReusableModal": function() {
		return Promise.all([__webpack_require__.e(4223), __webpack_require__.e(3460), __webpack_require__.e(9124), __webpack_require__.e(4141), __webpack_require__.e(4920), __webpack_require__.e(8803), __webpack_require__.e(6855)]).then(function() { return function() { return (__webpack_require__(6855)); }; });
	}
};
var get = function(module, getScope) {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(function() {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = function(shareScope, initScope) {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: function() { return get; },
	init: function() { return init; }
});